import axios from "axios";
import apiURI from "../Api";

export default class SellerService {
  async postRegisterSeller(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password,
    currency,
    language,
    transactionID,
    country,
    internationalCode,
    localCode,
    phoneNumber,
    latitude,
    longitude,
    voucher = null,
    paymentMethod = null,
    transferbankReceipt = null
  ) {
    const registerSeller = {
      transferbankReceipt: transferbankReceipt,
      currency: currency,
      latitude: typeof latitude === "string" ? parseFloat(latitude) : latitude,
      longitude: typeof longitude === "string" ? parseFloat(longitude) : longitude,
      paymentGateway: {
        id: 1,
      },
      paymentMethod: {
        id: paymentMethod ? paymentMethod : voucher ? 2 : 1,
      },
      paymenttransactionID: voucher ? voucher : transactionID,
      plan: {
        id: 4,
      },
      referee: {
        username: referee,
      },
      seller: {
        documentNumber: null,
        email: email,
        firstname: fname,
        password: password,
        surname: lname,
        username: username,
        language: language,
        country: country,
        internationalCode: internationalCode,
        localCode: localCode,
        phoneNumber: phoneNumber,
        originRegister: JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
          ? "MOBILE"
          : "WEB",
      },
    };

    const response = await axios.post(`${apiURI}/seller/register`, registerSeller);
    return response.data;
  }

  async upgrade(token, username, transactionID, hasVoucher) {
    const bodyJson = {
      paymentGateway: { id: 1 },
      paymentMethod: { id: hasVoucher ? 2 : 1 },
      paymenttransactionID: transactionID,
      plan: { id: 4 },
      username: username,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/seller/upgrade`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }
}
